module.exports = __webpack_public_path__ + "static/img/huodongshuoming.ade4fe2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/activity/2020/pc/huodongshuoming.png
// module id = L2E8
// module chunks = 69